<template>
  <div class="history-box">
    <div class="intro-year text-center red font30 normal-lineheight" style="left: 376px;top: 335px;">
      <p class="m0">2015</p>
      <p class="m0 lighter">面世</p>
    </div>
    <div class="intro-year text-center red font30" style="left: 668px;top: 440px;">
      <p class="m0">2016</p>
    </div>
    <div class="intro-year text-right red font30" style="left: 884px;top: 254px;">
      <p class="m0">2017</p>
      <p class="m0 lighter">快速发展</p>
    </div>
    <div class="intro-year text-left red font30" style="left: 1198px;top: 292px;">
      <p class="m0">2017.7</p>
      <p class="m0 lighter">第三轮融资完成</p>
    </div>
    <div class="intro-year text-left red font30" style="left: 1484px;top: 385px;">
      <p class="m0">2018</p>
    </div>
    <div v-for="(item, $index) in points" :key="$index">
      <div v-if="item.text" :class="item.text.class" :style="item.text.style">
        {{item.text.content}}
      </div>
      <div class="point-zone" :style="{ position:'absolute', left:(item.point.left-point.width/2)+'px', top: (item.point.top - point.height/2)+'px',width: point.width+'px',height: point.height+'px' }"
           @mouseover="showText(item)"
           @mouseout="hideText(item)">
        <span class="point p1"></span>
        <span v-if="item.text" class="point p2"></span>
        <span v-if="item.text" class="point p3"></span>
      </div>
    </div>
    <svg width="1920" height="900" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 900">
      <linearGradient id="linear-gradient" x1="0.5" y1="1" x2="0.5" gradientUnits="objectBoundingBox">
        <stop offset="0" stop-color="#ff2a00" stop-opacity="0"/>
        <stop offset="1" stop-color="#ff2a00" stop-opacity="0.6"/>
      </linearGradient>
      <g id="组_334" data-name="组 334" transform="translate(0 -112)">
        <path id="路径_259" data-name="路径 259" class="cls-1" d="M1920,1031V321.7c-97.7,25.4-193.7,242.6-432,262.5-204.6,17.1-269.8-148.4-482-98C837,526.3,812.1,630,644,644.2c-177.1,15-224.6-93.7-416-78-22.6,1.9-135.3,12.7-228,69.6V1031Z"/>
        <path id="路径_266" data-name="路径 266" class="cls-2" d="M264.9,564.7c150.2,0,206.2,81,346.2,81,10.5,0,21.4-.5,32.9-1.4,168.1-14.2,193-117.9,362-158,28.2-6.7,53.8-9.6,77.6-9.6,145.7,0,218.5,108.8,375.1,108.8,9.5,0,19.2-.4,29.3-1.2,238.3-19.9,334.3-237.1,432-262.5v-4h0a3.4,3.4,0,0,0-1,.1c-36.7,9.5-73,45.2-115,86.5-74.1,72.8-166.3,163.4-316.3,175.9-9.8.8-19.5,1.2-29,1.2-78.8,0-136.8-28.2-192.9-55.5-27-13.1-54.9-26.7-84.5-36.7-33.2-11.2-65.2-16.7-97.7-16.7-25.3,0-51,3.2-78.5,9.7-79.1,18.8-126.4,51-172.2,82.1-51.5,35.1-100.2,68.2-189.2,75.8-11.1.9-22,1.4-32.6,1.4-68,0-115.2-19-165.1-39.1-51.1-20.6-103.8-41.8-181.1-41.8-12.1,0-24.6.5-37.2,1.6a613.691,613.691,0,0,0-88.3,14.2C86,589.1,39.1,607.5,0,631.2v4.7c92.7-57,205.4-67.8,228-69.6C240.9,565.2,253.2,564.7,264.9,564.7Z"/>
      </g>
      <g id="animateG" transform="translate(0 750)">
        <path d="M0 20
                    C480 120 800 -60 1280 0
                    S1600 20 1920 30 V140 H0 Z"
              transform="translate(0 -20)"
              style="fill: #FF918C;" />
        <path d="M0 0
                    C480 -160 800 160 1280 60
                    S1600 0 1920 30 V160 H0 Z"
              transform="translate(0 -40)"
              style="fill: #FF6651;" />
        <path d="M0 0
                    C640 -120 800 100 1280 40
                    S1800 -20 1920 -20 V120 H0 Z" style="fill:#FF2A00;" />
      </g>
    </svg>
  </div>
</template>

<script>
  import BeziorCurve from '@/api/bezier'
  import MultiAnimate from '@/api/animate'

  export default {
    data() {
      return {
        point:{
          width: 70,
          height: 70
        },
        points:[
          {
            point:{
              left: 418,
              top: 480,
            },
            text:{
              content: '果小7便利小站自2015年面世以来,已在全国市场累计投放3500余个,服务近百万用户的便利消费需求。',
              transition: 'fade-in-down',
              class: {
                'hide': true,
                'intro-box':true,
                'red': true,
                'font18': true
              },
              style: {
                left: '376px',
                top: '180px',
              }
            },
          },
          {
            point: {
              left: 705,
              top: 516
            }
          },
          {
            point: {
              left: 952,
              top: 388
            },
            text: {
              content: '果小7依托强大的供应链体系及高智能化的管理模���,快速覆盖南京、武汉、成都、广州等市场。',
              transition: 'fade-in-down',
              class: {
                'hide': true,
                'intro-box':true,
                'red': true,
                'font18': true
              },
              style: {
                left: '848px',
                top: '82px'
              }
            }
          },
          {
            point: {
              left: 1245,
              top: 405
            },
            text: {
              content: '果小7成功完成第三轮融资,加速投入第三代智能柜的研发及全国市场的拓展。',
              transition: 'fade-in-down',
              class: {
                'hide': true,
                'intro-box':true,
                'red': true,
                'font18': true
              },
              style: {
                left: '1180px',
                top: '180px'
              }
            }
          },
          {
            point: {
              left: 1527,
              top: 464
            }
          }
        ]
      }
    },
    mounted() {
      var paths = document.getElementById('animateG').children;

      var ant = new MultiAnimate({
        transitions: [
          {
            delay: 0,
            endPath: ' V140 H0 Z',
            actions:[
              { x: 480, from: 120, to: -120, current: 120},
              { x: 800, from: -60, to: 60, current: -60},
              { x: 1280, from: 0, to: 0, current: 0 },
              { x: 1600, from: 20, to:-20, current: 20 },
              { x: 1920, from: 30, to: -30, current: 30 }
            ]
          },
          {
            delay: 250,
            endPath: ' V160 H0 Z',
            actions:[
              { x: 480, from: -160,to: 160,  current: -160 },
              { x: 800, from: 160, to: -160, current: 160 },
              { x: 1280, from: 60,  to: -60,  current: 60 },
              { x: 1600, from: 0, to: -20, current: 0 },
              { x: 1920, from: 30, to: -30, current: 30 }
            ]
          },
          {
            delay: 500,
            endPath: ' V120 H0 Z',
            actions: [
              {x: 640,  from: -120, to: 120, current: -120 },
              {x: 800,  from:  100, to: -100, current: 100 },
              {x: 1280, from:   40, to: -40, current: 40 },
              {x: 1800, from:  -20, to: 20, current: -20 },
              {x: 1920, from:  -20, to: 20, current: -20 }
            ]
          }
        ],
        ontransition(transitionObj, rate, index) {
          var pathDom = paths[index];
          var actions = transitionObj.actions;

          var pathC = 'C';
          var pathS = 'S';

          for(var index  in actions){
            if(index < 3){
              pathC +=`${actions[index].x} ${actions[index].current} `
            }else{
              pathS +=`${actions[index].x} ${actions[index].current} `
            }
          }

          pathDom.setAttribute('d', 'M0 0 ' + pathC + pathS + transitionObj.endPath)
        },
        onreverse(){},
        //来回变换 一次一段duraion
        reverse: true,
        duration: 1000,
        infinite: true
      })

      ant.run();
    },
    methods: {
      hideText(point){
        if(!point.text) return;
        point.text.class.hide = true;
        point.text.class[point.text.transition] = false;
      },
      showText(point){
        if(!point.text) return;
        point.text.class.hide = false;
        point.text.class[point.text.transition] = true;
      }
    }
  }
</script>

<style scoped>
  @import '../../static/css/point.css';

  .cls-1 {
    fill: url(#linear-gradient);
  }

  .cls-2 {
    fill: red;
  }

  .history-box{
    position: relative;
  }

  .intro-year{
    position: absolute;
  }

  .intro-box{
    position: absolute;
    width: 273px;
    border: 1px solid #FF2A00;
    line-height: 24px;
    padding: 10px;
  }

  .fade-in-down{
    animation: fadeInDown .5s ease;
  }

  .fade-in-up{
    animation: fadeInUp .5s ease;
  }
</style>



// WEBPACK FOOTER //
// src/components/History.vue